import { IconButton, twClassMerge } from '@healthhub/react-ui';
import type { ReactNode } from 'react';

import { OutlinedCloseIcon, PortalFilledShieldIcon } from '@shared/assets-icon';
import { MaxWidthContainer } from '@shared/components';

interface AntiSinGovWrapperProps {
  children: ReactNode;
  handleIconCloseClick?: () => void;
  isImportantNoticeShown: boolean;
}

const AntiSinGovWrapper = ({ children, handleIconCloseClick, isImportantNoticeShown }: AntiSinGovWrapperProps) => (
  <div
    className={twClassMerge('flex justify-center bg-primary-yellow py-4 px-3 lg:px-18', {
      'mb-1 shadow-[2px_2px_4px_0px_rgba(0,0,0,0.15)]': !isImportantNoticeShown,
      'border-b border-[#F3BA58]': isImportantNoticeShown,
    })}
  >
    <MaxWidthContainer className="flex justify-between gap-3 items-start">
      <div className="flex gap-2">
        <PortalFilledShieldIcon className="size-6px shrink-0" />
        {children}
      </div>
      <IconButton
        aria-label="Close"
        icon={<OutlinedCloseIcon className="size-6 shrink-0 [&_path]:fill-black" />}
        onClick={handleIconCloseClick}
      />
    </MaxWidthContainer>
  </div>
);

export default AntiSinGovWrapper;
